<template>
  <header class="page-header">
    <nav>
        <router-link  to="/Login" class="button" >Returning User Log in</router-link>
        <router-link to="/about" class="button">About the Program</router-link>
    </nav>
  </header>
</template>


<script>
export default {
  name: "SiteHeader",
  methods: {
    goToChat() {
      this.$router.push("/chat/situation/new/");
      this.changeMode("chat");
    }
  }
};
</script>